<style lang="scss">
@import "~animate.css";

* {
  font-family: "PingFang SC", "Microsoft YaHei";
}
.cat-contact {
  width: 4rem;
  height: 4rem;
  background-image: url("/media/yintai/cat-contact.png");
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  right: 1rem;
  top: 50%;
  z-index: 99999;
}
.el-dialog__header {
  background-color: #fff;

}
.el-dialog__title{
   font-size: 1.8rem;
  font-family: "PingFang SC", "Microsoft YaHei";
}
.el-dialog__body {
  background-color: #fff;
}
.el-dialog__footer {
  background-color: #fff;
}

.tiptip {

  font-size: 1.4rem;
  font-family: "PingFang SC", "Microsoft YaHei";
  margin-left: 10%;
  margin-top: 5%;
}
</style>
<template>
  <div>
    <YTHeader></YTHeader>
    <a target="_black" href="https://miaojie.sobot.com/chat/pc/v6/index.html?sysnum=9cdc44fea3f44ff6a7c7c7a10a54e280&source=2&robotid=1"
      ><div class="cat-contact"></div
    ></a>

    <router-view></router-view>
    <YTFooter></YTFooter>
  </div>
</template>

<script>
import YTHeader from "@/yintai/view/layout/header/Header.vue";
import YTFooter from "@/yintai/view/layout/footer/Footer.vue";

export default {
  name: "Layout",
  components: {
    YTHeader,
    YTFooter,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  beforeMount() {},
  mounted() {},
  methods: {},
  computed: {},
};
</script>
